module.exports = __webpack_public_path__ + "static/058_anagl_bazarek3-52ef6be23fc6aab8c6b6c053c71e9108.jpg";